const $$splitComponentImporter = () => import('/app/frontend/src/routes/_app/org-units/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_app/org-units/')({
  staticData: {
    breadCrumb: 'Org Units'
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});